import { configureStore } from '@reduxjs/toolkit';
import loginSlice from './reducers/auth/loginSlice';
import signupSlice from './reducers/auth/signupSlice';
import userSlice from './reducers/userSlice';
import userInfoReducer from './reducers/userInfoSlice';

const configureAppStore = configureStore({
  reducer: {
    login: loginSlice,
    signup: signupSlice,
    user: userSlice,
    userInfo: userInfoReducer,
  },
});

export type RootState = ReturnType<typeof configureAppStore.getState>;
export type AppDispatch = typeof configureAppStore.dispatch;

export default configureAppStore;